import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed, PropType } from 'vue';
import useI18n from '@/mixins/useI18n';
import useFormattedDateTime, { TimeFormatting } from '@/mixins/useFormattedDateTime';
import InvoicePositionsTableCell from '@/views/my-projects/components/invoice/positions/InvoicePositionsTableCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAttachmentFileTable',
  props: {
  files: {
    type: Array as PropType<any[] >,
    required: true
  },
  isReduced: Boolean
},
  setup(__props) {

const props = __props;



const filesWithNumbers = computed(() => props.files.map((file, i) => ({ ...file, nr: i + 1 })));
const { getFormattedTimeByAge } = useFormattedDateTime();
const { t } = useI18n();

const fieldNames = computed(() => (props.isReduced ? ['nr', 'name'] : ['nr', 'date', 'name']));
const headerTitles = computed(() => fieldNames.value.map((fieldName) => t(`invoice.attachments.table.columns.${fieldName}`)));

const sortCallback = (field: string, obj: any) => obj[field];

const displayCallback = (field: string, obj: any) => {
  if (field === 'date') {
    return getFormattedTimeByAge(obj.date, TimeFormatting.ChatMessageOverview);
  }
  return obj[field];
};


return { __sfc: true,props, filesWithNumbers, getFormattedTimeByAge, t, fieldNames, headerTitles, sortCallback, displayCallback, BCXTable, InvoicePositionsTableCell }
}

})